// extracted by mini-css-extract-plugin
export default {"main":"DSIAgents_main__eMUGT","header":"DSIAgents_header__9ZA8r","tabs":"DSIAgents_tabs__Bazy4","tab":"DSIAgents_tab__dDMQJ font-sm-regular"};